import HardBreak from '@tiptap/extension-hard-break';
import { Selection } from '@tiptap/pm/state';

// Needed for sending on Enter functionality. Has a problem with removing list items
export default HardBreak.extend({
  addKeyboardShortcuts() {
    const originalEnterHandler = () => {
      this.editor.commands.first(({ commands }) => [
        () => commands.liftEmptyBlock(),
        () => commands.newlineInCode(),
        () => commands.splitListItem('listItem'),
        () => commands.splitBlock(),
        () => commands.createParagraphNear(),
      ]);
      return true;
    };
    const backSpaceHandler = () => {
      this.editor.commands.first(({ commands }) => [
        () => commands.undoInputRule(),
        () => commands.command(({ tr }) => {
          const { selection, doc } = tr;
          const { empty, $anchor } = selection;
          const { pos, parent } = $anchor;
          const $parentPos = $anchor.parent.isTextblock && pos > 0 ? tr.doc.resolve(pos - 1) : $anchor;
          const parentIsIsolating = $parentPos.parent.type.spec.isolating;

          const parentPos = $anchor.pos - $anchor.parentOffset;

          const isAtStart =
            parentIsIsolating && $parentPos.parent.childCount === 1
              ? parentPos === $anchor.pos
              : Selection.atStart(doc).from === pos;

          if (
            !empty ||
            !parent.type.isTextblock ||
            parent.textContent.length ||
            !isAtStart ||
            (isAtStart && $anchor.parent.type.name === 'paragraph') // prevent clearNodes when no nodes to clear, otherwise history stack is appended
          ) {
            return false;
          }
          return commands.clearNodes();
        }),
        () => commands.deleteSelection(),
        () => commands.joinBackward(),
        () => commands.selectNodeBackward(),
      ]);
    };
    return {
      'Ctrl-Enter': originalEnterHandler,
      'Cmd-Enter': originalEnterHandler,
      'Shift-Enter': originalEnterHandler,
      Backspace: backSpaceHandler,
    };
  },
});
